
import React, { Component } from 'react';
import { Modal, Form, Input} from 'antd';

import http from '../../../axios/http';

const FormItem = Form.Item;

class WechatMsgTemplateEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            const {editData} = this.props;
            if(editData.state) {
                values["state"] = editData.state;
            }
            if(editData.id) {
                values["id"] = editData.id;
                values["templateCode"] = editData.templateCode;
                values["templateId"] = editData.templateId;
            }
            http.post({
                url: '/wx/msgTemplate/save',
                data: values,
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                }
            });
        });
    };

    render() {
        const { visible, onCancel, form, editData } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={800}
                visible={visible}
                title="模板编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    <FormItem label="模板名称：">
                        {getFieldDecorator('templateName', {
                            initialValue: editData.templateName
                        })(
                            <Input />
                        )}
                    </FormItem>
                    {editData.id ? "" : <FormItem label="模板编码：">
                        {getFieldDecorator('templateCode', {
                            initialValue: editData.templateCode
                        })(
                            <Input />
                        )}
                    </FormItem>}
                    {editData.id ? "" : <FormItem label="模板id：">
                        {getFieldDecorator('templateId', {
                            initialValue: editData.templateId
                        })(
                            <Input />
                        )}
                    </FormItem>}
                    <FormItem label="消息概要：">
                        {getFieldDecorator('first', {
                            initialValue: editData.first
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="消息备注：">
                        {getFieldDecorator('remark', {
                            initialValue: editData.remark
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="跳转路径：">
                        {getFieldDecorator('url', {
                            initialValue: editData.url
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="跳转小程序appid：">
                        {getFieldDecorator('miniAppid', {
                            initialValue: editData.miniAppid
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="跳转小程序路径：">
                        {getFieldDecorator('miniPagepath', {
                            initialValue: editData.miniPagepath
                        })(
                            <Input />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const WechatMsgTemplateEdit = Form.create()(WechatMsgTemplateEditForm);

export default WechatMsgTemplateEdit;